import {Component, ElementRef, OnDestroy, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {environment} from '@environments/environment';
import {ActivatedRoute} from "@angular/router";
import {AuthService} from "@app/_services/auth.service";
import {ThoughtspotService} from "@app/_services/thoughtspot.service";
import {MetadataSearchResponse} from "@thoughtspot/rest-api-sdk";
import {Action, LiveboardEmbed} from "@thoughtspot/visual-embed-sdk";
import {IdentityUser} from "@app/_models/identityUser";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-liveboard',
    imports: [],
    templateUrl: './liveboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './liveboard.component.scss'
})
export class LiveboardComponent implements OnDestroy {
    @ViewChild("liveboard") liveboard!: ElementRef;

    private routeSub: Subscription;
    private userSubscription: Subscription;

    environment = environment;
    liveboardId: string = "";
    user: IdentityUser | null = null;

    constructor(private route: ActivatedRoute, private authService: AuthService, private thoughtspotService: ThoughtspotService) {
        this.userSubscription = this.authService.user().subscribe((user: IdentityUser | null) => this.user = user);

        this.routeSub = this.route.queryParams.subscribe(params => {
            this.liveboardId = params['id'];
            this.thoughtspotService.initEmbedSDK();
            this.loadPage();
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
        this.userSubscription.unsubscribe();
    }

    private loadPage() {
        this.thoughtspotService.getLiveboardMetadata(this.liveboardId)
        .then(
            (response: MetadataSearchResponse[]) => {
                if (response == null) {
                    this.authService.signout().subscribe(() => {
                        this.authService.logout();
                    });
                    return;
                }

                const entity: MetadataSearchResponse = response.pop()!;
                let visibleActions = environment.thoughtSpotConfig.defaultVisibleActions;

                if (entity.metadata_header.tags.length == 0) {
                    visibleActions = visibleActions.concat(environment.thoughtSpotConfig.additionalVisibleActions);
                }

                this.renderLiveboard(visibleActions);
            }
        )
    }

    private renderLiveboard(visibleActions: Action[]) {
        const liveboardEmbed = new LiveboardEmbed(this.liveboard.nativeElement, {
            liveboardV2: true,
            liveboardId: this.liveboardId,
            showLiveboardDescription: true,
            showLiveboardTitle: true,
            linkOverride: true,

            frameParams: {
                width: "100%",
                height: "100%"
            },
            visibleActions: visibleActions
        });

        liveboardEmbed.render().then();
    }
}
